import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import { getDataFromAPI } from "../../../../HandleAPICalls/actions";
import { useNavigate, useParams } from "react-router-dom";
import toastr from "react-redux-toastr";
import PartnerBillSummaryComponent from "./component";

const PartnerBillSummaryContainer = ({ getDataFromAPI }) => {
  const navigate = useNavigate();
  const { id, billId,franchiseeId } = useParams();
  const [billData, setBillData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [payoutBillData, setPayoutBillData] = useState([]);
  const [partnerId, setPartnerId] = useState([]);
  const [getBillId, setGetBillId] = useState(null);
  const [chargeSummery, setChargeSummery] = useState(null);
  const [getFranchiseeId, setGetFranchiseeId] = useState("")
   const [allCharges, setAllCharges] = useState(null);
         const [chargesLoading, setChargesLoading] = useState(false);

  useEffect(() => {
    // First, fetch the partner ID data to get the actual billId
    fetchPartnerIDData();
  }, [billId]); // Only depend on billId from URL params

  useEffect(() => {
    // Only fetch bill data and payout data when getBillId is available
    if (getBillId) {
      fetchBillData();
      fetchPayoutBillData();
    }
  }, [getBillId]); // Only depend on getBillId


useEffect(() => {
    const id = franchiseeId || getFranchiseeId;
    if (id) {
      fetchAllCharges(id);
    }
  }, [franchiseeId, getFranchiseeId]);

  const fetchAllCharges = (franchiseeId) => {
    if (!franchiseeId) {
      console.warn("No franchiseeId provided to fetch charges");
      return;
    }

    setChargesLoading(true);
    getDataFromAPI(
      `/dashboard/api/v2/admin/platform/beneficiary/franchisee/${franchiseeId}/charge`,
      'GET',
      undefined,
      (response) => {
        console.log("All charges response:", response);
        setAllCharges(response);
        setChargesLoading(false);
      },
      (err) => {
        console.error("API Error:", err);
        toastr.error("Error", err.message || "Failed to load charges");
        setChargesLoading(false);
      }
    );
  };

  const fetchPartnerIDData = () => {
    setLoading(true);
    getDataFromAPI(
      `/partner/api/v3/acc/partnerId/${billId}`,
      "GET",
      undefined,
      (response) => {
        setPartnerId(response);
        setGetBillId(response.billId);
           if (response.franchiseeId) {
          fetchAllCharges(response.franchiseeId);
        }
        setLoading(false);
      },
      (err) => {
        console.error("Error fetching partner data:", err);
        setLoading(false);
      }
    );
  };
const fetchChargeBillSummery = (payoutId) => {
      if (!payoutId) {
        toastr.warning("Warning", "No payout ID available");
        return;
      }
      
      setLoading(true);
      getDataFromAPI(
        `/partner/api/v3/acc/payout/${payoutId}/deduction`,
        'GET',
        undefined,
        (response) => {
          setChargeSummery(response);
          setLoading(false);
        },
        (err) => {
          console.error("API Error:", err);
          toastr.error(err.message || "Error", "Failed to load charge summary");
          setLoading(false);
        }
      );
    };
  const fetchBillData = () => {
    setLoading(true);
    getDataFromAPI(
      `/partner/api/v3/acc/bills/${getBillId}/charges`,
      "GET",
      undefined,
      (response) => {
        setBillData(response);
         setGetFranchiseeId(response.franchiseeId)
        setLoading(false);
      },
      (err) => {
        console.error("Error fetching bill:", err);
        setLoading(false);
      }
    );
  };

  const fetchPayoutBillData = () => {
    setLoading(true);
    getDataFromAPI(
      `/partner/api/v3/acc/bill/${getBillId}/payout`,
      "GET",
      undefined,
      (response) => {
        console.log("payout response", response);
        setPayoutBillData(response);
        setLoading(false);
      },
      (err) => {
        console.error("Error fetching bill payout:", err.message);
        toastr.error("Error", err.message);
        setLoading(false);
      }
    );
  };

  const formatDate = (dateString) => {
    if (!dateString) return "N/A";
    return new Date(dateString).toLocaleDateString("en-US", {
      year: "numeric",
      month: "long",
      day: "numeric",
    });
  };

  const handleGoBack = () => navigate(-1);
  
  const handleMiscCharge = () => {
    navigate(`/home/configuration/partner/bills/miscellaneous-charge`, {
      state: {
        franchiseeId: billData?.franchiseeId, 
        partnerName: billData?.name, 
      },
    });
  };
const handlePostBill = () =>{
    navigate(`/home/configuration/partner/bills/post-bills/${getFranchiseeId}`)
  }
  return (
    <PartnerBillSummaryComponent
      loading={loading}
      billData={billData}
      onGoBack={handleGoBack}
      payoutBillData={payoutBillData}
      handleMiscCharge={handleMiscCharge}
      chargeSummery={chargeSummery}
      fetchChargeBillSummery={fetchChargeBillSummery}
      handlePostBill={handlePostBill}
      partnerId={partnerId}
       allCharges={allCharges}
    />
  );
};

export default connect(null, { getDataFromAPI })(PartnerBillSummaryContainer);